import {useState} from 'react';
import {DEFAULT_PAGE_SIZE, DEFAULT_TABLE_DATA} from '../constants';

export const useTableState = ({defaultTableData = DEFAULT_TABLE_DATA, defaultQuery = { per_page: DEFAULT_PAGE_SIZE }, defaultLoading = true} = {}) => {
  const [tableData, setTableData] = useState(defaultTableData);
  const [tableQuery, setTableQuery] = useState(defaultQuery);
  const [loading, setLoading] = useState(defaultLoading);
  const [requiredUpdate, setRequiredUpdate] = useState(true);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const finishTableLoading = () => setLoading(false);

  return {
    tableData, setTableData,
    tableQuery, setTableQuery,
    loading, setLoading,
    requiredUpdate, setRequiredUpdate,
    selectedRowKeys, setSelectedRowKeys,
    finishTableLoading
  };
}
